export const NEW_PROJECT = 'NEW_PROJECT';
export const EDIT_PROJECT = 'EDIT_PROJECT';
export const NEXT_STAGE = 'NEXT_STAGE';
export const NEW_PROJECT_FORM_VALUE_CHANGE = 'NEW_PROJECT_FORM_VALUE_CHANGE';
export const NEW_PROJECT_GC_SET = 'NEW_PROJECT_GC_SET';
export const NEW_PROJECT_CURRENT_PAGE_SET = 'NEW_PROJECT_CURRENT_PAGE_SET';
export const NEW_PROJECT_CLIENT_FORM_VALUE_CHANGE =
  'NEW_PROJECT_CLIENT_FORM_VALUE_CHANGE';
export const NEW_PROJECT_BUILDING_FORM_VALUE_CHANGE =
  'NEW_PROJECT_BUILDING_FORM_VALUE_CHANGE';
export const NEW_PROJECT_NEW_CLIENT_MODAL_SHOW =
  'NEW_PROJECT_NEW_CLIENT_MODAL_SHOW';
export const NEW_PROJECT_NEW_CLIENT_FORM_CLEAN =
  'NEW_PROJECT_NEW_CLIENT_FORM_CLEAN';
export const NEW_PROJECT_NEW_BUILDING_MODAL_SHOW =
  'NEW_PROJECT_NEW_BUILDING_MODAL_SHOW';
export const NEW_PROJECT_NEW_BUILDING_FORM_CLEAN =
  'NEW_PROJECT_NEW_BUILDING_FORM_CLEAN';
export const NEW_PROJECT_ID_SET = 'NEW_PROJECT_ID_SET';
export const EDIT_PROJECT_FORM_SET_VALUES = 'EDIT_PROJECT_FORM_SET_VALUES';



// WEBPACK FOOTER //
// ./src/components/admin/projects/creation/store/action-types.js